// extracted by mini-css-extract-plugin
export default {"container":"BoardEditor_container__VOfSW"};